module.exports = new Promise(resolve => {
      if(document.getElementById('ipru_remote')) {
        resolve(window.ipru_remote);
        return;
      }
      const script = document.createElement('script');
      script.src = '/etc.clientlibs/aem-ipru-common-preprod/clientlibs/clientlib-react/resources/remoteEntry.js?v=' + Date.now();
      script.id = 'ipru_remote';
      script.onload = () => {
        resolve(window.ipru_remote);
      };
      document.head.appendChild(script);
    });